import React, { useEffect, useState } from "react";
import {
  View,
  StyleSheet,
  Modal,
  TouchableWithoutFeedback,
} from "react-native";
import moment from "moment";
import ConfirmedOrder from "./ConfirmedOrder";
import { useSelector } from "react-redux";
import {
  getIsOrderProcessing,
  getLastPlacedOrder,
} from "@/app/selectors/order";
import { getEnableAsyncFlowForTpos } from "@/app/selectors/config";

const ORDER_CONFIRMATION_DISPLAY_DURATION = 10;
const ASYNC_ORDER_CONFIRMATION_DISPLAY_DURATION = 60;

const OrderConfirmModal = () => {
  const [showModal, setShowModal] = useState(false);
  const lastOrder = useSelector(getLastPlacedOrder);
  const isOrderProcessing = useSelector(getIsOrderProcessing);
  const isAsyncEnabled = useSelector(getEnableAsyncFlowForTpos);
  const isAsyncOrderReady =
    lastOrder && !isOrderProcessing && lastOrder.albaikIdentifier != null;
  const canShow = isAsyncEnabled ? isAsyncOrderReady : Boolean(lastOrder);
  const displayDuration = isAsyncEnabled
    ? ASYNC_ORDER_CONFIRMATION_DISPLAY_DURATION
    : ORDER_CONFIRMATION_DISPLAY_DURATION;

  useEffect(() => {
    if (canShow) {
      const orderTime = moment.unix(lastOrder.createdAt);
      const timeDifference = moment().diff(orderTime, "seconds");
      setShowModal(timeDifference < displayDuration);
    } else {
      setShowModal(false);
    }
  }, [canShow, displayDuration, lastOrder]);

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <Modal
      transparent={true}
      animationType="fade"
      visible={showModal}
      onRequestClose={handleClose}
      accessibilityViewIsModal={true}
    >
      <TouchableWithoutFeedback onPress={handleClose}>
        <View
          style={styles.backdrop}
          accessible={true}
          accessibilityRole="alert"
          accessibilityLabel="Order confirmation dialog"
        >
          <TouchableWithoutFeedback>
            <ConfirmedOrder order={lastOrder} onNewOrderPress={handleClose} />
          </TouchableWithoutFeedback>
        </View>
      </TouchableWithoutFeedback>
    </Modal>
  );
};

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContent: {
    backgroundColor: "white",
    padding: 20,
    borderRadius: 10,
    alignItems: "center",
  },
  modalText: {
    fontSize: 18,
    fontWeight: "bold",
  },
});

export default OrderConfirmModal;
